function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17 3.34H7L2 12l5 8.66h10L22 12l-5-8.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.87 14H7.03L5.1 17.33l1.93 3.33h3.84l1.93-3.33L10.87 14z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M14.34 8H7.03l-3.65 6.33 3.65 6.33h7.31L18 14.33 14.34 8z"
})));